/* File : src/pages/GuestPages/RetrieveTicketPage.js */
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import { publicApi } from '../../services/api';
import './GuestPages.css';

/**
 * Page permettant de récupérer son ticket via le numéro de téléphone
 * VERSION CORRIGÉE : Avec vérification correcte de la structure de réponse API
 */
const RetrieveTicketPage = () => {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const inputRef = useRef(null);
  
  // Auto-focus sur l'input au chargement
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);
  
  const handlePhoneChange = (e) => {
    // Garder seulement les chiffres
    let input = e.target.value.replace(/\D/g, '');
    
    // Limiter à 9 chiffres
    if (input.length > 9) {
      input = input.slice(0, 9);
    }
    
    setPhone(input);
    setError('');
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation du numéro de téléphone camerounais
    if (!phone || phone.length !== 9) {
      setError('Veuillez entrer un numéro de téléphone complet (9 chiffres)');
      return;
    }
    
    // Vérifier que le numéro commence par 6
    if (!phone.startsWith('6')) {
      setError('Le numéro doit commencer par 6 (ex: 677123456)');
      return;
    }
    
    // Vérifier le deuxième chiffre (doit être 2, 4, 5, 6, 7, 8 ou 9)
    const secondDigit = phone.charAt(1);
    if (!['2', '4', '5', '6', '7', '8', '9'].includes(secondDigit)) {
      setError('Format de numéro invalide');
      return;
    }
    
    setLoading(true);
    
    try {
      console.log('Vérification inscription pour:', phone);
      
      // Vérifier si l'utilisateur est déjà inscrit
      const response = await publicApi.checkRegistration(phone);
      
      console.log('Réponse API complète:', response);
      console.log('response.data:', response.data);
      
      // ✅ CORRECTION CRITIQUE : Structure réelle de la réponse
      // Backend retourne: {success, status_code, message, data: {registered, user}, timestamp}
      // Axios encapsule dans response.data
      // Donc: response.data.data.registered est le bon chemin
      
      const backendData = response.data;
      console.log('Données backend:', backendData);
      
      if (backendData && backendData.data && backendData.data.registered) {
        console.log('✅ Utilisateur trouvé, redirection vers ticket');
        console.log('User data:', backendData.data.user);
        
        // Rediriger vers la page du ticket avec le numéro de téléphone
        navigate(`/ticket/${phone}`);
      } else {
        console.log('❌ Utilisateur non trouvé ou non inscrit');
        setError('Aucune inscription trouvée avec ce numéro de téléphone.');
        setLoading(false);
      }
    } catch (err) {
      console.error('Erreur vérification inscription:', err);
      console.error('err.response:', err.response);
      
      // Message d'erreur plus précis selon le type d'erreur
      if (err.response) {
        if (err.response.status === 404) {
          setError('Aucune inscription trouvée avec ce numéro de téléphone.');
        } else if (err.response.data && err.response.data.message) {
          setError(err.response.data.message);
        } else {
          setError('Une erreur est survenue. Veuillez réessayer.');
        }
      } else if (err.request) {
        setError('Impossible de se connecter au serveur. Vérifiez votre connexion.');
      } else {
        setError('Une erreur inattendue est survenue.');
      }
      
      setLoading(false);
    }
  };
  
  const handleBackToEvent = () => {
    navigate('/event');
  };
  
  return (
    <div className="guest-page retrieve-ticket-page">
      <div className="retrieve-ticket-container">
        <div className="back-arrow" onClick={handleBackToEvent}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 12H5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M12 19L5 12L12 5" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <div className="retrieve-ticket-header">
          <img src="/assets/images/guinness-logo.png" alt="Guinness Cameroun" className="retrieve-ticket-logo" />
          <h1>Retrouver mon pass</h1>
          <p>Entrez le numéro de téléphone utilisé lors de votre inscription</p>
        </div>
        
        <div className="retrieve-ticket-form-container">
          <form onSubmit={handleSubmit} className="retrieve-ticket-form">
            <div className="form-group">
              <label htmlFor="phone">Numéro de téléphone</label>
              <input
                ref={inputRef}
                type="tel"
                id="phone"
                name="phone"
                className={`form-input ${error ? 'error' : ''}`}
                placeholder="677123456"
                value={phone}
                onChange={handlePhoneChange}
                maxLength={9}
                required
                disabled={loading}
                autoComplete="tel"
              />
              <small className="form-hint">Format : 9 chiffres (ex: 677123456)</small>
              {error && <div className="error-message">{error}</div>}
            </div>
            
            <div className="retrieve-ticket-actions">
              <Button
                type="submit"
                variant="guinness"
                size="lg"
                fullWidth
                disabled={loading || phone.length !== 9}
              >
                {loading ? 'Recherche en cours...' : 'Retrouver mon pass'}
              </Button>
              
              <button
                type="button"
                className="text-button"
                onClick={handleBackToEvent}
                disabled={loading}
              >
                Retour à l'événement
              </button>
            </div>
          </form>
        </div>
        
        <div className="retrieve-ticket-footer">
          <div className="age-restriction">
            <span className="age-restriction-circle">21+</span>
            <p>NE PAS TRANSFERER AUX PERSONNES AGEES DE MOINS DE 21 ANS</p>
          </div>
          <p>A CONSOMMER AVEC MODERATION</p>
          <p className="drinkiq">www.drinkiq.com</p>
        </div>
      </div>
    </div>
  );
};

export default RetrieveTicketPage;